import { useEffect } from 'react';
import { useOperatingSystem } from '@elfsight/lib-utils';
import { useSettings } from '@wu/widget-core';
import type { A11yState } from '../../types';
import { createStyles } from '../styles/create-styles';
import { useDemoToggle } from './use-demo-toggle';

const STYLE_ID = 'eapps-accessibility-styles';

export function useCreateStyle(storedA11yData: A11yState | undefined) {
  const { editMode } = useSettings();
  const { toggleState } = useDemoToggle();
  const os = useOperatingSystem();

  useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.id = STYLE_ID;

    document.head.appendChild(styleElement);

    return () => {
      const existingElement = document.getElementById(STYLE_ID);

      if (existingElement) {
        document.head.removeChild(existingElement);
      }
    };
  }, []);

  useEffect(() => {
    const styleElement = document.getElementById(STYLE_ID);

    if (styleElement) {
      styleElement.innerHTML = storedA11yData
        ? createStyles(storedA11yData, os, editMode, toggleState)
        : '';
    }
  }, [storedA11yData, os, editMode, toggleState]);
}
